import {FC} from 'react';
import {Box, useMediaQuery} from '@mui/material';
import Payments from './Payments';
import History from './History';

const ProfileBilling: FC = () => {
	const isLaptop = useMediaQuery('(min-width:1025px)');

	return (
		<Box sx={{display: 'flex', flexDirection: 'column', height: '100%'}}>
			{isLaptop && <Payments />}
			<History />
		</Box>
	);
};

export default ProfileBilling;
